<div class="flex flex-row gap-8 mt-4">
  @for (item of data?.slice(0, 4); track $index) {
  <ui-card class="flex-1" [noBorder]="true">
    <ng-container content>
      <div class="flex gap-2 items-end">
        <span class="general-card-title">{{ item.value + item.unitMeasure }}</span>
        <span class="general-card-subtitle">{{ item.title }}</span>
      </div>
      <!-- <div class="flex flex-wrap gap-3 mt-5">
        <div class="flex flex-row gap-2">
          <ui-icon name="minus" color="#868686" size="20px"></ui-icon>
          <div>0.00</div>
        </div>
        <div>+0.00% в этом году</div>
      </div> -->
    </ng-container>
  </ui-card>
  }
</div>

<div class="general-info-divider"></div>

<div class="flex flex-row gap-8 mt-4 mb-4">
  @for (item of data?.slice(4); track $index) {
  <ui-card class="flex-1" [noBorder]="true">
    <ng-container content>
      <div class="flex gap-2 items-end">
        <span class="general-card-title">{{ item.value + item.unitMeasure }}</span>
        <span class="general-card-subtitle">{{ item.title }}</span>
      </div>
      <!-- <div class="flex flex-wrap gap-3 mt-5">
        <div class="flex flex-row gap-2">
          <ui-icon name="fall" color="#E02523" size="20px"></ui-icon>
          <div>10.2</div>
        </div>
        <div>-1.01% на этой неделе</div>
      </div> -->
    </ng-container>
  </ui-card>
  }
</div>
